import { createAsyncThunk } from '@reduxjs/toolkit';
import { localStorageUtil } from '../utils/localStorageUtils';
import { userDataAPI } from '../API/services';
import { dispatchUtil } from '../utils/dispatchUtil';
import { setUserAction } from '../actions';
import { getErrorTypeFromApi } from '../utils/ErrorHandling/errorUtil';

export const fetchUserData = createAsyncThunk(
  'user/fetchUserData',
  async (params = {}, { rejectWithValue }) => {
    const { accessToken = null, setUserSessionOnSuccess = false } = params;
    try {
      const requestConfig = {};

      // Given that the endpoint used to login does not return user information
      // only the accessToken, we use this thunk to fetch the user data using
      // a provided token because cached token is not available
      if (accessToken?.token) {
        requestConfig.headers = { Authorization: accessToken.token };
      }

      const response = await userDataAPI(requestConfig, {});

      if (response.status !== 200) {
        return rejectWithValue(getErrorTypeFromApi(response));
      }

      const user = response.data.data;

      // Also this thunk can set the user session in local storage and global
      // state because in this moment we have all the information needed to
      // set the user session
      if (setUserSessionOnSuccess && accessToken?.token) {
        localStorageUtil.setUserSession({ ...user, token: accessToken });
      } else {
        dispatchUtil.dispatch(setUserAction(user));
      }

      return user;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
